<div>
    <div class="actionGridContainer">
        <loader class="loader" [size]="'medium'" *ngIf="displayLoader"></loader>

        <div *ngIf="!displayLoader">
            <ng-container *ngIf="pageData?.actions?.length == 0; else dataTable">
                <div class="no-actions-found">
                    No actions found for state {{currPageState}}
                </div>
            </ng-container>
            <ng-template #dataTable>
                <div class="table-header-row">
                    <app-search-sort-bar 
                        (searchData)="searchData($event)" 
                        (clearAll)="clearSearch()"
                        (filter)="setFilter($event)" 
                        (sortSelection)="sortBySelection($event)"
                        (setOpportunityType)="setOpportunityType($event)"
                        [length]="availableData?.length" 
                        [pageSize]="25" 
                        [pageIndex]="currPageIndex"
                        (page)="pageChanged($event)"
                        [inMyActions]="currPageState === 'My Actions'"
                    >
                    </app-search-sort-bar>
                </div>
                <ng-container *ngIf="availableData?.length == 0; else actions">
                    <div class="no-actions-found">
                        No actions available for the filters chosen
                    </div>
                </ng-container>
                <ng-template #actions>
                    <div class="table-header">
                        <app-table-row 
                            [currPageState]="currPageState" 
                            [header] = "true"
                            [opportunityType]="dataManipulationOptions.opportunityType">
                        </app-table-row>        
                    </div>
                    <div *ngFor="let data of dataToDisplay">
                        <app-table-row [currPageState]="currPageState" [dataRow]="data"
                            [opportunityType]="dataManipulationOptions.opportunityType">
                        </app-table-row>
                    </div>
                </ng-template>
            </ng-template>
        </div>
    </div>
</div>